import { Grid, MenuItem, Select, Typography } from '@mui/material';
import { helperText } from '../assets/theme/Theme';

function CustomDropdown({
	label,
	data,
	error,
	items,
	onChange,
	placeholder,
	width = '100%',
}) {
	return (
		<Grid container flexDirection={'column'} paddingTop={'5px'}>
			<Typography
				fontSize={'14px'}
				color={'#7C7C7C'}
				marginBottom={'5px'}>
				{label}
			</Typography>
			<Select
				size="small"
				fullWidth
				value={data}
				error={error?.status}
				displayEmpty
				renderValue={value => {
					if (!value) {
						return (
							<Typography color="#cacdd4" fontSize={'14px'}>
								{placeholder}
							</Typography>
						);
					}
					return value;
				}}
				onChange={onChange}
				sx={{
					backgroundColor: '#FFFFFF',
					color: '#777E90',
					marginTop: '5px',
					width: width,
				}}>
				{items.map((item, index) => {
					return (
						<MenuItem key={index} value={item}>
							{item}
						</MenuItem>
					);
				})}
			</Select>
			<Typography style={helperText}>{error?.msg}</Typography>
		</Grid>
	);
}

export default CustomDropdown;
